import { render, staticRenderFns } from "./AnnotationCard.vue?vue&type=template&id=597015b3&scoped=true&"
import script from "./AnnotationCard.vue?vue&type=script&lang=js&"
export * from "./AnnotationCard.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationCard.vue?vue&type=style&index=0&id=597015b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597015b3",
  null
  
)

export default component.exports